import '@fortawesome/fontawesome-free/css/all.min.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import DocumentoDinamico from "./components/DocumentoDinamico";

import Inicio from './components/Inicio/Inicio';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Transparencia from './components/Transparencia/Transparencia';
import Ligasdeinteres from './components/Ligasdeinteres/Ligasdeinteres';
import Normativos from './components/Normativos/Normativos';
import Pada from './components/Pada/Pada';
import Convenios from './components/Convenios/Convenios';
import Contratos from './components/Contratos/Contratos';
import Etica from './components/Etica/Etica';
import Cocodi from './components/Cocodi/Cocodi';
import Cocodidoc01 from './components/Cocodidocs/Cocodidoc01';
import Dn01 from './components/Dnormativos/Dn01';
import Dn02 from './components/Dnormativos/Dn02';
import Dn04 from './components/Dnormativos/Dn04';
import Dn07 from './components/Dnormativos/Dn07';
import Dn09 from './components/Dnormativos/Dn09';
import Dn10 from './components/Dnormativos/Dn10';
import Dn11 from './components/Dnormativos/Dn11';
import Dn12 from './components/Dnormativos/Dn12';
import Dn13 from './components/Dnormativos/Dn13';
import Dn14 from './components/Dnormativos/Dn14';
import Dn15 from './components/Dnormativos/Dn15';
import Psejemplo from './components/Psejemplo/Psejemplo';
import Pvivienda from './components/Pvivienda/Pvivienda';
import Psbienydes from './components/Psbienydes/Psbienydes';
import Psbienydes2024 from './components/Psbienydes2024/Psbienydes2024';
import Avisosprivacidad from './components/Avisosprivacidad/Avisosprivacidad';
import Psatencionpue2024 from './components/Psatencionpue2024/Psatencionpue2024';
import Psatencionm2024 from './components/Psatencionm2024/Psatencionm2024';
import Pb2022 from './components/Pb2022/Pb2022';
import Pb2023 from './components/Pb2023/Pb2023';
import Pb2024 from './components/Pb2024/Pb2024';
import Pb2025 from './components/Pb2025/Pb2025';
import Pb2026 from './components/Pb2026/Pb2026';
import PAAAS from './components/PAAAS/PAAAS';
import Psdesinc2024 from './components/Psdesinc2024/Psdesinc2024';
import Ps2023 from './components/Ps2023/Ps2023';
import Cn2024 from './components/Cn2024/Cn2024';
import Rc2024 from './components/Rc2024/Rc2024';
import Rcs2024 from './components/Rcs2024/Rcs2024';
import Rops2024 from './components/Rops2024/Rops2024';
import Rops2025 from './components/Rops2025/Rops2025';
import Rops2026 from './components/Rops2026/Rops2026';
import Psbienmas from './components/Psbienmas/Psbienmas';
import Psbienmas2024 from './components/Psbienmas2024/Psbienmas2024';
import Psbienyprod2024 from './components/Psbienyprod2024/Psbienyprod2024';
import Psfomentops2024 from './components/Psfomentops2024/Psfomentops2024';
import Psfomentoa2024 from './components/Psfomentoa2024/Psfomentoa2024';
import Psbiendisc from './components/Psbiendisc/Psbiendisc';
import Psfomdps from './components/Psfomdps/Psfomdps';
import Psfomart from './components/Psfomart/Psfomart';
import Psatencionm from './components/Psatencionm/Psatencionm';
import Psatencionpam from './components/Psatencionpam/Psatencionpam';
import Psatencionpam2024 from './components/Psatencionpam2024/Psatencionpam2024';
import Psatencionjuv from './components/Psatencionjuv/Psatencionjuv';
import Psatencionjuv2024 from './components/Psatencionjuv2024/Psatencionjuv2024';
import Desarrolloinclusivo from './components/Programassociales/Desarrolloinclusivo';
import DI2026 from './components/DI2026/DI2026';
import DGSP from './components/DGSP/DGSP';
import DGSC from './components/DGSC/DGSC';
import BPCD from './components/BPCD/BPCD';
import Heh from './components/Consultas/Heh';
import Tpa from './components/Consultas/Tpa';
import Artesanos from './components/Consultas/Artesanos';
import Migrantes from './components/Consultas/Migrantes';
import Inclusion from './components/Consultas/Inclusion';
import FCartesanos from './components/Consultas/FCartesanos';
import HHidalguense from './components/Consultas/HHidalguense';
import Otepehua from './components/Consultas/Otepehua';
import Vmezquital from './components/Consultas/Vmezquital';
import Feriasf from './components/Consultas/Feriasf';
import Atencionalpueblo from './components/Programassociales/Atencionalpueblo';
import Bienestarydesarrollo from './components/Programassociales/Bienestarydesarrollo';
import Madrestrabajadoras from './components/Programassociales/Madrestrabajadoras';
import SubsidioVerificacion from './components/Programassociales/SubsidioVerificacion';
import BienestarArtesanos from './components/Programassociales/BienestarArtesanos';
import Fomentoartesanal from './components/Programassociales/Fomentoartesanal';
import Atencionmigrante from './components/Programassociales/Atencionmigrante';
import Adultosmayores from './components/Programassociales/Adultosmayores';
import Cuidadores from './components/Programassociales/Cuidadores';
import Juventud from './components/Programassociales/Juventud';
import Beneficiarios from './components/Beneficiarios/Beneficiarios';
import Resultados from './components/Resultados/Resultados'; 
import Rubros from './components/Rubros/Rubros';
import Convocatorias from './components/Convocatorias/Convocatorias';
import Con01 from './components/Convs/Con01';
import Con02 from './components/Convs/Con02';
import Con03 from './components/Convs/Con03';
import Con04 from './components/Convs/Con04';
import Con05 from './components/Convs/Con05';
import Con06 from './components/Convs/Con06';
import Con07 from './components/Convs/Con07';
import Con08 from './components/Convs/Con08';
import Con09 from './components/Convs/Con09';
import Conv001 from './components/Convocatorias/Conv001';
import Conv002 from './components/Convocatorias/Conv002';
import Conv003 from './components/Convocatorias/Conv003';
import Conv004 from './components/Convocatorias/Conv004';
import Conv005 from './components/Convocatorias/Conv005';
import Conv006 from './components/Convocatorias/Conv006';
import PBPA from './components/PBPA/PBPA';
import Cinterno from './components/Cinterno/Cinterno';
import Metodologia from './components/Cinterno/Metodologia';
import Control from './components/Cinterno/Control';
import Organigrama from './components/Cinterno/Organigrama';
import Evidencias from './components/Cinterno/Evidencias';
import CPBPA from './components/Convocatorias/CPBPA';
import CCDP from './components/Convocatorias/CCDP';
import CCOMP from './components/Convocatorias/CCOMP';
import FUPS from './components/Convocatorias/FUPS';
import SOA from './components/Convocatorias/SOA';
import BYD from './components/Convocatorias/BYD';
import BMT from './components/Convocatorias/BMT';
import AEFS from './components/Convocatorias/AEFS';
import Artesaniasvm2026 from'./components/Convocatorias/Artesaniasvm2026';
import Artesaniashh2026 from './components/Convocatorias/Artesaniashh2026';
import Bordadosot2026 from './components/Convocatorias/Bordadosot2026';
import Capacitacionartesanos2026 from './components/Convocatorias/Capacitacionartesanos2026';
import Aefsconv from './components/Convocatorias/Aefsconv';
import Programas from './components/Programas/Programas';
import Historico from './components/Historico/Historico';
import DetalleRubro from './components/DetalleRubro/DetalleRubro';
import RubrosHistoricos from "./components/RubrosHistoricos/RubrosHistoricos";
import Agenda from "./components/Agenda/Agenda";
import ArmonizacionContable from "./components/ArmonizacionContable/ArmonizacionContable";
import Licitaciones from "./components/Licitaciones/Licitaciones";
import Servicios from "./components/Servicios/Servicios";
import Byp1024 from "./components/Folios/Byp1024";
import Error404 from "./components/Error404/Error404";
import Dinc1024 from "./components/Folios/Dinc1024";
import { Armonizacion } from "./json/armonizacionContable";
import { Disciplina } from "./json/disciplinaFinanciera";

function App() {
  return (
    <BrowserRouter>
      <Header/>
        <Routes>
          
          <Route path="/documento/:id" element={<DocumentoDinamico />} />
          <Route exact path="/" element={ <Inicio /> } />
          <Route exact path="/Transparencia" element={ <Transparencia/> } />
          <Route exact path="/Ligasdeinteres" element={ <Ligasdeinteres/> } />
          <Route exact path="/Ligasdeinteres/Convocatorias" element={ <Convocatorias/> } />
          <Route exact path="/Convocatorias/Con01" element={ <Con01/> } />
          <Route exact path="/Convocatorias/Con02" element={ <Con02/> } />
          <Route exact path="/Convocatorias/Con03" element={ <Con03/> } />
          <Route exact path="/Convocatorias/Con04" element={ <Con04/> } />
          <Route exact path="/Convocatorias/Con05" element={ <Con05/> } />
          <Route exact path="/Convocatorias/Con06" element={ <Con06/> } />
          <Route exact path="/Convocatorias/Con07" element={ <Con07/> } />
          <Route exact path="/Convocatorias/Con08" element={ <Con08/> } />
          <Route exact path="/Convocatorias/Con09" element={ <Con09/> } />
          <Route exact path="/Ligasdeinteres/Etica" element={ <Etica/> } />
          <Route exact path="/Ligasdeinteres/Cocodi" element={ <Cocodi/> } />
          <Route exact path="/Cocodi/Cocodidoc01" element={ <Cocodidoc01/> } />
          <Route exact path="/Dn01" element={ <Dn01/> } />
          <Route exact path="/Dn02" element={ <Dn02/> } />
          <Route exact path="/Dn04" element={ <Dn04/> } />
          <Route exact path="/Dn07" element={ <Dn07/> } />
          <Route exact path="/Dn09" element={ <Dn09/> } />
          <Route exact path="/Dn10" element={ <Dn10/> } />
          <Route exact path="/Dn11" element={ <Dn11/> } />
          <Route exact path="/Dn12" element={ <Dn12/> } />
          <Route exact path="/Dn13" element={ <Dn13/> } />
          <Route exact path="/Dn14" element={ <Dn14/> } />
          <Route exact path="/Dn15" element={ <Dn15/> } />
          <Route exact path="/Convocatorias/Conv001" element={ <Conv001/> } />
          <Route exact path="/Convocatorias/Conv002" element={ <Conv002/> } />
          <Route exact path="/Convocatorias/Conv003" element={ <Conv003/> } />
          <Route exact path="/Convocatorias/Conv004" element={ <Conv004/> } />
          <Route exact path="/Convocatorias/Conv005" element={ <Conv005/> } />
          <Route exact path="/Convocatorias/Conv006" element={ <Conv006/> } />
          <Route exact path="/Convocatorias/CPBPA" element={ <CPBPA/> } />
          <Route exact path="/Convocatorias/BYD" element={ <BYD/> } />
          <Route exact path="/Convocatorias/BMT" element={ <BMT/> } />
          <Route exact path="/Convocatorias/AEFS" element={ <AEFS/> } />
          <Route exact path="/Convocatorias/Artesaniasvm2026" element={ <Artesaniasvm2026/> } />
          <Route exact path="/Convocatorias/Artesaniashh2026" element={ <Artesaniashh2026/> } />
          <Route exact path="/Convocatorias/Bordadosot2026" element={ <Bordadosot2026/> } />
          <Route exact path="/Convocatorias/Capacitacionartesanos2026" element={ <Capacitacionartesanos2026/> } />
          <Route exact path="/Convocatorias/Aefsconv" element={ <Aefsconv/> } />
          <Route exact path="/Formatos/CCDP" element={ <CCDP/> } />
          <Route exact path="/Formatos/CCOMP" element={ <CCOMP/> } />
          <Route exact path="/Formatos/FUPS" element={ <FUPS/> } />
          <Route exact path="/Formatos/SOA" element={ <SOA/> } />
          <Route exact path="/Beneficiarios" element={ <Beneficiarios/> } />
          <Route exact path="/Programas" element={ <Programas/> } />
          <Route exact path="/Programas/Historico" element={ <Historico/> } />
          <Route exact path="/Resultados" element={ <Resultados/> } />
          <Route exact path="/Psejemplo" element={ <Psejemplo/> } />
          <Route exact path="/Pvivienda" element={ <Pvivienda/> } />
          <Route exact path="/Psbienydes" element={ <Psbienydes/> } />
          <Route exact path="/Programas/Psbienydes2024" element={ <Psbienydes2024/> } />
          <Route exact path="/Avisosprivacidad" element={ <Avisosprivacidad/> } />
          <Route exact path="/Programas/Psatencionpue2024" element={ <Psatencionpue2024/> } />
          <Route exact path="/Programas/Psatencionm2024" element={ <Psatencionm2024/> } />
          <Route exact path="/Programas/Psatencionpam2024" element={ <Psatencionpam2024/> } />  
          <Route exact path="/Programas/Pb2022" element={ <Pb2022/> } />
          <Route exact path="/Programas/Pb2023" element={ <Pb2023/> } />
          <Route exact path="/Programas/Pb2024" element={ <Pb2024/> } />
          <Route exact path="/Programas/Pb2025" element={ <Pb2025/> } />
          <Route exact path="/Programas/Pb2026" element={ <Pb2026/> } />
          <Route exact path="/Programas/Psdesinc2024" element={ <Psdesinc2024/> } />
          <Route exact path="/Programas/Psfomentops2024" element={ <Psfomentops2024/> } />
          <Route exact path="/Programas/Psfomentoa2024" element={ <Psfomentoa2024/> } />
          <Route exact path="/Rops2024" element={ <Rops2024/> } />
          <Route exact path="/Rops2025" element={ <Rops2025/> } />
          <Route exact path="/Rops2026" element={ <Rops2026/> } />
          <Route exact path="/PAAAS" element={ <PAAAS/> } />
          <Route exact path="/Ps2023" element={ <Ps2023/> } />
          <Route exact path="/Cn2024" element={ <Cn2024/> } />
          <Route exact path="/Rc2024" element={ <Rc2024/> } />
          <Route exact path="/Rcs2024" element={ <Rcs2024/> } />
          <Route exact path="/Psbienmas" element={ <Psbienmas/> } />
          <Route exact path="/Programas/Psbienmas2024" element={ <Psbienmas2024/> } />
          <Route exact path="/Programas/Psbienyprod2024" element={ <Psbienyprod2024/> } />
          <Route exact path="/Psbiendisc" element={ <Psbiendisc/> } />
          <Route exact path="/Psfomdps" element={ <Psfomdps/> } />
          <Route exact path="/Psfomart" element={ <Psfomart/> } />
          <Route exact path="/Psatencionm" element={ <Psatencionm/> } />
          <Route exact path="/Psatencionpam" element={ <Psatencionpam/> } />
          <Route exact path="/Psatencionjuv" element={ <Psatencionjuv/> } />
          <Route exact path="/Programas/Psatencionjuv2024" element={ <Psatencionjuv2024/> } />
          <Route exact path="/Programas/Psbienyprod2024" element={ <Psbienyprod2024/> } />
          <Route exact path="/Transparencia/Normativos" element={ <Normativos/> } />
          <Route exact path="/Transparencia/Pada" element={ <Pada/> } />
          <Route exact path="/Transparencia/Contratos" element={ <Contratos/> } />
          <Route exact path="/Transparencia/Rubros" element={ <Rubros/> } />
          <Route exact path="/Transparencia/Rubros/DetalleRubro/:nombre" element={ <DetalleRubro/> } />
          <Route exact path="/Transparencia/Rubros/RubrosHistoricos" element={ <RubrosHistoricos/> } />
          <Route exact path="/Transparencia/Convenios" element={ <Convenios/> } />
          <Route exact path="/Agenda" element={ <Agenda/> } />
          <Route exact path="/Armonizacion" element={ <ArmonizacionContable data={Armonizacion} title="Armonizacion Contable" dataType="/Armonizacion" /> } />
          <Route exact path="/Disciplina" element={ <ArmonizacionContable data={Disciplina} title="Disciplina Financiera" dataType="/Disciplina" /> } />
          <Route exact path="/Licitaciones" element={ <Licitaciones /> } />
          <Route exact path="/Servicios" element={ <Servicios /> } />
          <Route exact path="/Folios/Byp1024" element={ <Byp1024 /> } />
          <Route exact path="/Folios/Dinc1024" element={ <Dinc1024 /> } />
          <Route exact path="*" element={<Error404 /> } />
          <Route exact path="/Programas/Desarrolloinclusivo" element={ <Desarrolloinclusivo/> } />
          <Route exact path="/Programas/DI2026" element={ <DI2026/> } />
          <Route exact path="/DGSP" element={ <DGSP/> } />
          <Route exact path="/DGSC" element={ <DGSC/> } />
          <Route exact path="/BPCD" element={ <BPCD/> } />
          <Route exact path="/PBPA" element={ <PBPA/> } />
          <Route exact path="/Cinterno" element={ <Cinterno/> } />
          <Route exact path="/Cinterno/Metodologia" element={ <Metodologia/> } />
          <Route exact path="/Cinterno/Control" element={ <Control/> } />
          <Route exact path="/Cinterno/Organigrama" element={ <Organigrama/> } />
          <Route exact path="/Cinterno/Evidencias" element={ <Evidencias/> } />
          <Route exact path="/Consultas/Heh" element={ <Heh/> } />
          <Route exact path="/Consultas/Tpa" element={ <Tpa/> } />
          <Route exact path="/Resultados/BienestarArtesanos" element={ <Artesanos/> } />
          <Route exact path="/Resultados/Migrantes" element={ <Migrantes/> } />
          <Route exact path="/Resultados/Inclusion" element={ <Inclusion/> } />
          <Route exact path="/Resultados/FCartesanos" element={ <FCartesanos/> } />
          <Route exact path="/Resultados/HHidalguense" element={ <HHidalguense/> } />
          <Route exact path="/Resultados/Otepehua" element={ <Otepehua/> } />
          <Route exact path="/Resultados/Vmezquital" element={ <Vmezquital/> } />
          <Route exact path="/Resultados/Feria-sf" element={ <Feriasf/> } />
          <Route exact path="/Programas/Atencionalpueblo" element={ <Atencionalpueblo/> } />
          <Route exact path="/Programas/Bienestarydesarrollo" element={ <Bienestarydesarrollo/> } />
          <Route exact path="/Programas/Madrestrabajadoras" element={ <Madrestrabajadoras/> } />
          <Route exact path="/Programas/SubsidioVerificacion" element={ <SubsidioVerificacion/> } />
          <Route exact path="/Programas/BienestarArtesanos" element={ <BienestarArtesanos/> } />
          <Route exact path="/Programas/Fomentoartesanal" element={ <Fomentoartesanal/> } />
          <Route exact path="/Programas/Atencionmigrante" element={ <Atencionmigrante/> } />
          <Route exact path="/Programas/Juventud" element={ <Juventud/> } />
          <Route exact path="/Programas/Adultosmayores" element={ <Adultosmayores/> } />
           <Route exact path="/Programas/Cuidadores" element={ <Cuidadores/> } />
        </Routes>
      <Footer/>
    </BrowserRouter>
  );
}

export default App;